import { Lightning, Colors } from '@lightningjs/sdk';

export default class SkipIntroBtn extends Lightning.Component {
  static _template() {
    return {
      Border: { collision: true },
    };
  }

  _handleHover() {
    this._focus();
    this.fireAncestors('$setState', 'SkipIntro');
  }

  _handleUnhover() {
    this._unfocus();
  }

  _focus() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(186, 81, 15, 3, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(186, 81, 15, 3, Colors('#D6D6D6').get(), false),
    });
  }

  _firstEnable() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(186, 81, 15, 3, Colors('#D6D6D6').get(), false),
    });
  }

  get _Border() {
    return this.tag('Border');
  }
}
